import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'

const isDev = process.env.NODE_ENV === 'development'

// fr/rw are code-split into their own chunks and only downloaded when the
// user switches language — keeping ~420KB of JSON out of the initial bundle.
// en stays bundled as the fallback language so first paint never waits.
const lazyLocales: Record<string, () => Promise<any>> = {
  fr: () => import('./locales/fr.json'),
  rw: () => import('./locales/rw.json'),
}

const LazyLocaleBackend = {
  type: 'backend' as const,
  init: () => undefined,
  read: (lng: string, _ns: string, callback: (err: unknown, data?: any) => void) => {
    const load = lazyLocales[lng]
    if (!load) return callback(null, {})
    load()
      .then((mod: any) => callback(null, mod.default ?? mod))
      .catch((err: unknown) => callback(err))
  },
}

// Only key-like strings (e.g. auth.login.title) are cut to their last segment; plain text keeps its periods
const looksLikeKey = /^[a-zA-Z][\w-]*(\.[\w-]+)*$/

const humanizeKey = (key: string): string => {
  const last = looksLikeKey.test(key) ? key.split('.').pop() || key : key
  const spaced = last.replace(/_/g, ' ')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

i18n
  .use(LazyLocaleBackend)
  .use(initReactI18next)
  .init({
    // en is bundled below; other languages come from LazyLocaleBackend
    partialBundledLanguages: true,
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    lng: 'en',
    debug: isDev,

    saveMissing: isDev,
    missingKeyHandler: (lngs, _ns, key) => {
      if (isDev) {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] Missing key "${key}" for languages: ${lngs.join(', ')}`)
      }
    },

    parseMissingKeyHandler: (key: string) => humanizeKey(key),

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
